import { Card, Flex, Grid, styled } from '@grupoboticario/flora-react';
import { NextButton, PreviousButton } from '@grupoboticario/flora-team-react-carousel';

import { ResponsiveFloraTypography } from 'components';

const styles = {
  Wrapper: styled(Flex, {
    padding: '$2 0',
  }),

  WithoutCarouselWrapper: styled(Grid, {
    gap: '$4',
    width: '100%',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($19 * 3), 1fr))',
    },
  }),

  CarouselWrapper: styled(Flex, {
    padding: '$2',
  }),

  EmptyStateWrapper: styled(Flex, {
    width: '100%',
  }),

  EmptyStateCard: styled(Card, {
    padding: '$2 $6',
    maxWidth: 'calc($22 * 3)',
  }),

  SkeletonWrapper: styled(Grid, {
    gap: '$4',
    margin: '$5',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($22 * 3), 1fr))',
    },
  }),
  TitleWrapper: styled(Flex, {
    paddingBottom: '$3',
  }),
  Description: styled(ResponsiveFloraTypography, {
    paddingBottom: '$4',
  }),

  PreviousButton: styled(PreviousButton, {
    '@tablet': {
      '&[data-to="previous"]&[data-interaction="prev"][data-flora="button"]': {
        left: '0',
      },
    },
    '@desktop': {
      '&[data-to="previous"]&[data-interaction="prev"][data-flora="button"]': {
        left: '-$6',
      },
    },
    '@fullscreen': {
      '&[data-to="previous"]&[data-interaction="prev"][data-flora="button"]': {
        left: '-$12',
      },
    },
  }),
  NextButton: styled(NextButton, {
    '@tablet': {
      '&[data-to="next"]&[data-interaction="next"][data-flora="button"]': {
        right: '0',
      },
    },
    '@desktop': {
      '&[data-to="next"]&[data-interaction="next"][data-flora="button"]': {
        right: '-$6',
      },
    },
    '@fullscreen': {
      '&[data-to="next"]&[data-interaction="next"][data-flora="button"]': {
        right: '-$12',
      },
    },
  }),
};

export default styles;
